import { SkpEnvironment } from "../entities";
import { useSkpEnvironment } from "../providers/environment";
import { useWindowDimensions } from "../hooks/useWindowDimensions";
import { Spacer } from "./layout";
import LocaleSwitcher from "./localeSwitcher";
import { useCssVarLogoUrl } from "../hooks/useCssVarLogoUrl";

type TopBannerProp = {
  hasMailboxLoaded: boolean;
};

/**
 * Top banner of the page.
 * @returns a JSX element representing the top banner of the page.
 */
export default function TopBanner({ hasMailboxLoaded }: TopBannerProp) {
  const environment: SkpEnvironment | undefined = useSkpEnvironment();
  const { isMobileWidth } = useWindowDimensions();
  return (
    <div
      style={{
        borderBottomColor: "var(--top-banner-bottom-border-color)",
        backgroundColor: "var(--logo-background-color)",
      }}
      className="flex h-12 flex-row items-center border-b-[1.8px] px-2 sm:h-20 sm:px-5"
    >
      {hasMailboxLoaded && <Logo />}
      <Spacer />
      {environment && !isMobileWidth && (
        <OrganizationName organizationName={environment.customerName} />
      )}
      <div className="w-4 sm:w-11" />
      <div className="items-center justify-end">
        <LocaleSwitcher />
      </div>
    </div>
  );
}

const Logo = () => {
  // Unlike the css default (which the bundler rewrites to the emitted asset),
  // this plain string is served as-is: public/ lands at the root, no prefix.
  const logoUrl = useCssVarLogoUrl() ?? "/assets/logos/teambeam.svg";

  return (
    <img
      src={logoUrl}
      alt="Logo"
      className="shrink-0 object-contain object-left p-2 sm:p-0"
      style={{
        height: "auto",
        width: "auto",
        maxHeight: "50px",
        display: "block",
      }}
    />
  );
};

type OrganizationNameProp = {
  organizationName: string;
};

const OrganizationName = ({ organizationName }: OrganizationNameProp) => (
  <div
    className="text-sm"
    style={{
      color: "var(--on-logo-background-color)",
    }}
  >
    {organizationName}
  </div>
);
